import React, { useEffect, useRef } from 'react';
import s from './s.module.less';

interface AlertChargeSuccessProps {
    patientName?: string;
    amount: number | string;
    onClose: () => void;
}

const AlertChargeSuccess: React.FC<AlertChargeSuccessProps> = ({ patientName, amount, onClose }) => {
    const time = useRef(5000);
    const ST = useRef<NodeJS.Timeout | null>(null);

    const deleteST = () => {
        if (ST.current) {
            clearTimeout(ST.current);
        }
    };

    useEffect(() => {
        ST.current = setTimeout(() => {
            onClose();
        }, time.current);

        return () => {
            deleteST();
        };
    }, []);

    return (
        <div className={s.alertWrap}>
            <span className={s.text}>
                You have charged {patientName || ''} ${amount} successfully
            </span>
            <button
                className={s.closeBtn}
                onClick={() => {
                    deleteST();
                    onClose();
                }}
                aria-label="Close"
                type="button"
            >
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="10" cy="10" r="10" fill="#ECFDF5" />
                    <path d="M13 7L7 13" stroke="#353535" strokeWidth="1.5" strokeLinecap="round" />
                    <path d="M7 7L13 13" stroke="#353535" strokeWidth="1.5" strokeLinecap="round" />
                </svg>
            </button>
        </div>
    );
};

export default AlertChargeSuccess;
